// If updating data -
// 1. download sheet as JSON with right property names as in `data/rawData`
// 2. use `formatFinalData` from `utils/helper` and copy paste it here

export const data = [
  {
    qId: 0,
    text: "What's your budget?",
    options: [
      {
        text: "Under $40",
        nextQId: 1,
        possibleResultsIds: [
          4, 5, 6, 7, 11, 12, 14, 19, 20, 21, 25, 27, 33, 34, 37, 41, 45, 48,
          49, 50, 53, 56, 57, 58, 60, 65, 71, 75, 76, 77, 78, 82, 84, 93, 94,
          95, 100, 103, 104, 106, 112, 113,
        ],
      },
      {
        text: "Under $100",
        nextQId: 1,
        possibleResultsIds: [
          2, 10, 14, 23, 24, 26, 28, 29, 32, 35, 37, 38, 40, 42, 43, 44, 46, 51,
          52, 59, 60, 61, 62, 66, 69, 70, 78, 79, 80, 81, 83, 90, 96, 98, 99,
          101, 102, 105, 107, 109, 114,
        ],
      },
      {
        text: "The sky's the limit",
        nextQId: 1,
        possibleResultsIds: [
          1, 8, 9, 13, 15, 16, 17, 18, 22, 26, 30, 31, 39, 43, 54, 55, 63, 64,
          67, 68, 72, 73, 74, 79, 85, 86, 87, 88, 89, 91, 92, 97, 108, 110, 111,
        ],
      },
    ],
  },
  {
    qId: 1,
    text: "The person you're shopping for...",
    options: [
      {
        text: "Has a well-stocked kitchen",
        nextQId: 2,
        possibleResultsIds: [
          2, 4, 5, 6, 7, 8, 9, 14, 16, 17, 18, 21, 22, 24, 26, 27, 28, 30, 31,
          32, 33, 34, 38, 39, 40, 41, 42, 45, 46, 48, 49, 50, 51, 52, 53, 55,
          58, 59, 60, 63, 64, 65, 69, 70, 72, 74, 75, 78, 79, 80, 81, 82, 83,
          84, 86, 91, 92, 94, 95, 96, 97, 100, 102, 104, 107, 108, 109, 110,
          111,
        ],
      },
      {
        text: "Still needs some basic tools",
        nextQId: 2,
        possibleResultsIds: [
          1, 7, 8, 11, 12, 13, 14, 19, 20, 22, 24, 25, 26, 27, 48, 31, 12, 29,
          23, 15, 16, 21, 10, 33, 34, 35, 37, 11, 29, 38, 39, 43, 44, 42, 54,
          55, 56, 57, 60, 61, 62, 63, 64, 66, 67, 68, 71, 72, 73, 75, 76, 77,
          78, 85, 86, 87, 88, 89, 90, 93, 98, 99, 101, 103, 105, 106, 112, 113,
          114,
        ],
      },
    ],
  },
  {
    qId: 2,
    text: "Which best describes the person you're shopping for?",
    options: [
      {
        text: "They’re big into camping",
        nextQId: 3,
        possibleResultsIds: [11, 25, 29, 30, 50, 51, 52, 53, 54, 55],
      },
      {
        text: "A coffee lover",
        nextQId: 4,
        possibleResultsIds: [
          4, 8, 11, 12, 23, 28, 38, 39, 40, 41, 56, 57, 58, 59, 60, 61, 62, 63,
          64, 103, 104, 105, 112,
        ],
      },
      {
        text: "An excellent dinner party host",
        nextQId: 6,
        possibleResultsIds: [
          1, 2, 6, 15, 16, 18, 19, 21, 22, 31, 35, 37, 44, 65, 66, 106, 107,
          109,
        ],
      },
      {
        text: "A tea enthusiast",
        nextQId: 7,
        possibleResultsIds: [
          9, 10, 23, 32, 33, 34, 41, 68, 67, 69, 108, 113, 114,
        ],
      },
      {
        text: "An avid baker",
        nextQId: 8,
        possibleResultsIds: [
          5, 7, 18, 20, 42, 43, 44, 45, 46, 48, 70, 71, 72, 73, 74,
        ],
      },
      {
        text: "A wine lover",
        nextQId: 9,
        possibleResultsIds: [
          24, 35, 47, 36, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
          88, 89, 90, 91, 92,
        ],
      },
      {
        text: "Just someone who loves to cook",
        nextQId: 10,
        possibleResultsIds: [
          1, 2, 4, 13, 15, 17, 18, 19, 21, 22, 24, 25, 43, 94, 95, 49, 25, 93,
          96, 99, 98, 17, 97, 73, 110,
        ],
      },
      {
        text: "A cocktail aficionado",
        nextQId: 11,
        possibleResultsIds: [14, 26, 27, 31, 57, 88, 100, 101, 102, 111],
      },
    ],
  },
  {
    qId: 3,
    text: "Do they camp...",
    options: [
      {
        text: "On foot, with tents",
        nextQId: null,
        possibleResultsIds: [11, 29, 52, 53, 55],
      },
      {
        text: "Out of a car, boat, etc. ",
        nextQId: null,
        possibleResultsIds: [25, 29, 30, 50, 51, 54],
      },
    ],
  },
  {
    qId: 4,
    text: "Do they prefer ... ",
    options: [
      {
        text: "Drip",
        nextQId: 5,
        possibleResultsIds: [8, 11, 23, 28, 41, 61, 112],
      },
      {
        text: "Pourover",
        nextQId: 5,
        possibleResultsIds: [8, 23, 56, 59, 60, 104],
      },
      {
        text: "Espresso",
        nextQId: 5,
        possibleResultsIds: [4, 12, 38, 39, 40, 41, 62, 103],
      },
      {
        text: "French press",
        nextQId: 5,
        possibleResultsIds: [4, 11, 23, 28, 61, 64, 41, 112],
      },
      {
        text: "Iced coffee all year, baby",
        nextQId: 5,
        possibleResultsIds: [28, 57, 58, 63, 105],
      },
    ],
  },
  {
    qId: 5,
    text: "Do they take milk and/or sugar?",
    options: [
      {
        text: "Yes",
        nextQId: null,
        possibleResultsIds: [
          12, 4, 8, 57, 58, 28, 39, 60, 38, 61, 63, 64, 105, 112,
        ],
      },
      {
        text: "No",
        nextQId: null,
        possibleResultsIds: [
          8, 11, 23, 28, 39, 40, 41, 56, 57, 58, 59, 62, 63, 64, 103, 104, 105,
        ],
      },
    ],
  },
  {
    qId: 6,
    text: "Is their signature dinner party trick...",
    options: [
      {
        text: "Impressive project cooking",
        nextQId: null,
        possibleResultsIds: [1, 2, 18, 19, 65, 66],
      },
      {
        text: "Executing the classics perfectly",
        nextQId: null,
        possibleResultsIds: [16, 21, 44, 109],
      },
      {
        text: "The best wine and cocktails",
        nextQId: null,
        possibleResultsIds: [6, 31, 35, 106],
      },
      {
        text: "Fun table decor",
        nextQId: null,
        possibleResultsIds: [6, 22, 37, 107],
      },
    ],
  },
  {
    qId: 7,
    text: "Do they prefer ... ",
    options: [
      {
        text: "Black and herbal teas",
        nextQId: null,
        possibleResultsIds: [10, 33, 32, 67, 108],
      },
      {
        text: "Green tea and matcha",
        nextQId: null,
        possibleResultsIds: [34, 32, 68, 108, 114],
      },
      {
        text: "All things tea...and they love to try new blends",
        nextQId: null,
        possibleResultsIds: [9, 10, 41, 67, 69, 113],
      },
    ],
  },
  {
    qId: 8,
    text: "What do they like to bake?",
    options: [
      {
        text: "They got into sourdough over the pandemic",
        nextQId: null,
        possibleResultsIds: [5, 18, 20, 42, 73],
      },
      {
        text: "They decorate cakes that could go in the window of a bakery",
        nextQId: null,
        possibleResultsIds: [44, 45, 46, 71, 72],
      },
      {
        text: "They’re obsessed with puddings and scones, thanks to a certain show",
        nextQId: null,
        possibleResultsIds: [43, 46, 48, 74],
      },
      {
        text: "They stick to the classics like cookies, brownies, and bars",
        nextQId: null,
        possibleResultsIds: [7, 43, 70, 74],
      },
    ],
  },
  {
    qId: 9,
    text: "What's in their glass on a Saturday night? ",
    options: [
      {
        text: "Big Napa reds",
        nextQId: null,
        possibleResultsIds: [77, 80, 84, 87, 90, 91],
      },
      {
        text: "Chilled light reds",
        nextQId: null,
        possibleResultsIds: [35, 76, 82, 83, 89, 92],
      },
      {
        text: "Pet-nats",
        nextQId: null,
        possibleResultsIds: [35, 76, 82, 83, 85, 92],
      },
      {
        text: "Fino sherry",
        nextQId: null,
        possibleResultsIds: [78, 86],
      },
      {
        text: "Something well-aged from the cellar",
        nextQId: null,
        possibleResultsIds: [75, 81, 88, 90, 91],
      },
      {
        text: "Crisp whites",
        nextQId: null,
        possibleResultsIds: [35, 76, 79, 84, 85],
      },
    ],
  },
  {
    qId: 10,
    text: "What do they like to cook? ",
    options: [
      {
        text: "Breakfast! ",
        nextQId: null,
        possibleResultsIds: [17, 43, 25, 94, 96],
      },
      {
        text: "Anything that's a project and gets the whole kitchen messy",
        nextQId: null,
        possibleResultsIds: [18, 3, 2, 19, 73, 95, 99],
      },
      {
        text: "Weeknight meals for family",
        nextQId: null,
        possibleResultsIds: [1, 25, 95, 96, 98, 110],
      },
      {
        text: "Dinners for one that aren't boring at all ",
        nextQId: null,
        possibleResultsIds: [15, 24, 49, 93, 97],
      },
    ],
  },
  {
    qId: 11,
    text: "What kind of cocktails do they like? ",
    options: [
      {
        text: "Brisk and potent",
        nextQId: null,
        possibleResultsIds: [26, 57, 100],
      },
      {
        text: "Classic and historical",
        nextQId: null,
        possibleResultsIds: [27, 31, 102, 101],
      },
      {
        text: "Every season is spritz season",
        nextQId: null,
        possibleResultsIds: [14, 88, 111],
      },
    ],
  },
]
